import { z } from "zod";

export const httpHeaderSchema = z.object({
	name: z.string(),
	value: z.string(),
});

export type HttpHeader = z.infer<typeof httpHeaderSchema>;
